jQuery(document).ready(function ($) {
    const swiperInfoTiles = new Swiper(".info-tiles", {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        cssMode: true,
        keyboard: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            420: {
                slidesPerView: 1,
            },
        },
    });

    const swiperCardSlider = new Swiper(".card-slider", {
        slidesPerView: 3,
        spaceBetween: 0,
        keyboard: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 3,
            },
        }
    })
});
